exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__mainsection___2ZuPf{\r\n  margin-top: 10px;\r\n}\r\n", "", {"version":3,"sources":["/./containers/App/style.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;CAClB","file":"style.css","sourcesContent":[".mainsection{\r\n  margin-top: 10px;\r\n}\r\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"mainsection": "style__mainsection___2ZuPf"
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../~/postcss-loader!./containers/App/style.css
 ** module id = 809
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../~/postcss-loader!./containers/App/style.css
 ** module id = 809
 ** module chunks = 1
 **/